module.exports = __webpack_public_path__ + "img/product-img5.002863bb.png";